import { BigNumber, ethers } from 'ethers'
import isNil from 'lodash/isNil'
import { getBep20Contract } from './contractHelpers'

const fetchTokenBalance = async ({
  tokenAddress,
  account,
  provider,
  chainId,
  decimals
}: {
  tokenAddress: string
  account: string
  provider: any
  chainId: number
  decimals: number
}): Promise<ethers.BigNumber> => {
  try {
    if (isNil(tokenAddress) || tokenAddress === '') {
      // Handle native token
      const nativeTokenBigNumberBalance = await provider.getBalance(account)
      return nativeTokenBigNumberBalance
    }
    // Handle BEP20 token
    const contract = getBep20Contract(tokenAddress, provider, chainId)
    const tokenBigNumerBalance = await contract.balanceOf(account)
    return tokenBigNumerBalance
  } catch (error) {
    console.error('Error fetching token balance:', error)
    return BigNumber.from(0)
  }
}

export default fetchTokenBalance
